"use client";

import { createContext, useContext, ReactNode } from "react";
import { useUrlState } from "@padi/lib/hooks/use-url-state";
import { useCropsFilters, UseCropsFilters } from "../_hooks/use-crops-filters";

interface CropsContextValue extends UseCropsFilters {
  currentPage: number;
  onPageChange: (page: number) => void;
}

const CropsContext = createContext<CropsContextValue | null>(null);

export function CropsProvider({ children }: { children: ReactNode }) {
  const { allParams, setParam, setParams, clearParams } = useUrlState();

  const currentPage = Number(allParams.page) || 1;

  const cropsFilters = useCropsFilters({
    urlParams: allParams,
    onFilterChange: setParam,
    onFiltersChange: setParams,
    onFiltersClear: clearParams,
  });

  const handlePageChange = (page: number) => {
    setParam("page", page);
  };

  return (
    <CropsContext.Provider
      value={{
        ...cropsFilters,
        currentPage,
        onPageChange: handlePageChange,
      }}
    >
      {children}
    </CropsContext.Provider>
  );
}

export function useCropsContext() {
  const context = useContext(CropsContext);
  if (!context) {
    throw new Error("useCropsContext must be used within CropsProvider");
  }
  return context;
}
